import { ref } from "vue";
const missingFeature = ref<string>("");
const upsellModalVisible = ref<boolean>(false);
const attemptedRoute = ref("");
export { upsellModalVisible, missingFeature, attemptedRoute };
